import { call, put, takeLatest } from 'redux-saga/effects';

import { fetchModulesDataApi } from '../../api';
import {
  fetchModulesData,
  modulesDataSuccess,
  modulesDataError,
} from '../slices/modulesSlice';

function* fetchModulesDataWorker(action) {
  try {
    const { status, ok, data } = yield call(
      fetchModulesDataApi,
      action.payload
    );

    if (ok) {
      yield put(modulesDataSuccess(data));
    } else {
      yield put(modulesDataError({ status, data }));
    }
  } catch (err) {
    throw new Error(`Error: ${err.message}`);
  }
}

export default function* modulesSaga() {
  yield takeLatest(fetchModulesData.type, fetchModulesDataWorker);
}
